import { useAppSelector } from 'dux/app/hooks';

import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

import { useCheckoutCategory } from 'Apps/Checkout/hooks/useCheckoutCategory';

import { Typography } from 'Components/Typography';

import useResponsiveVariant from 'utils/useResponsiveVariant';

import * as checkoutCartSelectors from 'dux/checkoutCart/selectors';

import CartPumpsOption from './CartPumpsOption';
import CheckoutBlock from './CheckoutBlock';

const Wrapper = styled.div`
  padding: 16px 24px;
  background-color: ${theme.colors.neutral[300]};
  line-height: 16px;
`;

const CheckoutReduceAndReuse = () => {
  const { isMobile } = useResponsiveVariant();

  const checkoutCategory = useCheckoutCategory();
  const shouldProposePumps = useAppSelector(state =>
    checkoutCartSelectors.shouldProposePumps(state, { checkoutCategory })
  );

  if (!shouldProposePumps) {
    return null;
  }

  return isMobile ? (
    <Wrapper data-testid="cart-reduce-and-reuse-section-mobile">
      <Typography inline medium variant="p3">
        Reduce and Reuse—
      </Typography>
      <CartPumpsOption />
    </Wrapper>
  ) : (
    <CheckoutBlock dataTestId="cart-reduce-and-reuse-section-desktop" title="Reduce &&nbsp;Reuse">
      <CartPumpsOption />
    </CheckoutBlock>
  );
};

export default CheckoutReduceAndReuse;
